var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox-group',{attrs:{"name":"multiples"},model:{value:(_vm.multiples),callback:function ($$v) {_vm.multiples=$$v},expression:"multiples"}},_vm._l((_vm.constantMultiplesOptions),function(o){return _c('b-form-checkbox',{key:o,attrs:{"value":o}},[_vm._v("\n      "+_vm._s(o)+"\n    ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53417f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/constant/Multiples.vue
// module id = null
// module chunks = 